import "core-js/modules/es.array.push.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47f1beda"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top-container flex align-center"
};
const _hoisted_2 = {
  key: 0,
  class: "edu-organization-wrap flex align-center"
};
const _hoisted_3 = {
  class: "title-name"
};
const _hoisted_4 = {
  class: "title-line"
};
const _hoisted_5 = {
  class: "top-org-user-info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "org-switch"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("["), /*#__PURE__*/_createElementVNode("span", null, "切换机构"), /*#__PURE__*/_createTextVNode("]")])], -1));
const _hoisted_7 = {
  class: "top-user-info"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "user-name"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    lineHeight: '26px'
  }
}, "个人线索采集二维码，用于采集线索使用，学员提交信息后跟进人为当前员工", -1));
import { computed, ref, onMounted, watch } from "vue";
import { useRoute } from 'vue-router';
import { useStore } from "vuex";
import Cookies from 'js-cookie';
import { navList } from "./Menu/constant";
import request from '@/utils/axios';
import ResetPassword from "components/RePassword";
import accountIcon from "@/assets/img/account-pic.png";
import iconCloudDiskStorage from '@/assets/img/icon-cloud-disk-storage.png';
export default {
  __name: 'TopContainer',
  props: {
    orgInfo: Object
  },
  setup(__props) {
    const store = useStore();
    const userInfo = computed(() => store.state.home.userInfo || {});
    const collapsed = computed(() => store.state.home.collapsed || false);
    let props = __props;
    const route = useRoute();
    const currentRoutes = computed(() => {
      let routes = [];
      for (let i = 0, count = navList.length; i < count; i++) {
        routes = [];
        let {
          children,
          ...other
        } = navList[i];
        if (other.path && other.path === route.path) {
          routes.push(other);
          break;
        } else if (children && children.length) {
          routes.push(other);
          let _ = children.find(item => item.path === route.path);
          if (_) {
            routes.push(_);
            break;
          }
        }
      }
      return routes;
    });
    const passVisible = ref(false);
    const userVisible = ref(false);
    const isAccount = ref(true);
    const accountAction = ref(false);
    const qRCodeForClueCollection = ref(false);
    const orgActive = ref();
    const orgList = ref([]);
    const personalQrcode = ref('');
    const logout = () => {
      request({
        baseURL: '/as',
        url: '/edu_web/logout',
        method: 'POST'
      }).then(res => {
        Cookies.set('Authorization', '');
        Cookies.set('EDU-ORGANIZATION', '');
        sessionStorage.setItem('oldToken', '');
        sessionStorage.setItem('oldOrganization', '');
        location.reload();
      });
    };
    watch(() => store.state.home.orgInfo, val => {
      openOrg();
    });
    const onChangeAccount = (val, val1) => {
      accountAction.value = val1;
      isAccount.value = val;
    };
    const onCloudHosting = () => {
      location.href = '#/home/cloudDiskStorage?tab=fileStorage';
    };
    const handleBeforeClose = done => {
      isAccount.value = true;
      accountAction.value = false;
      done && done();
    };
    const onCollapsed = () => {
      store.commit("home/setCollapsed", !collapsed.value);
    };
    const submitChangeOrg = val => {
      if (`${orgActive.value}` === `${val}`) {
        return false;
      }
      request({
        url: '/edu_home/auth/save_user_organization_default_flag',
        method: 'post',
        data: {
          eduOrganizationId: val
        }
      }).then(res => {
        Cookies.set('EDU-ORGANIZATION', val);
        sessionStorage.setItem("oldOrganization", val);
        location.href = '#/home';
        location.reload();
      });
    };
    /**
     * 线索采集二维码
     **/
    const onQRCodeForClueCollection = () => {
      getPersonalQrcode();
      qRCodeForClueCollection.value = true;
    };
    /**
     * 获取个人二维码
     */
    const getPersonalQrcode = () => {
      request({
        url: '/edu_user/auth/auth/get_personal_qrcode',
        method: 'get'
      }).then(res => {
        personalQrcode.value = res || '';
      });
    };
    const openOrg = () => {
      request({
        url: '/edu_home/auth/user_edu_list',
        method: 'get'
      }).then(res => {
        orgList.value = res || [];
      });
    };
    onMounted(() => {
      const eduOrganization = Cookies.get('EDU-ORGANIZATION');
      orgActive.value = eduOrganization;
      openOrg();
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        onClick: onCollapsed,
        class: _normalizeClass(["menu-collapse", {
          collapsed: collapsed.value
        }])
      }, null, 2), _unref(route).path === '/home' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.orgInfo.organizationName), 1), _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [[_vShow, __props.orgInfo.type === 2 || __props.orgInfo.status !== 0]]), __props.orgInfo.type === 2 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "title-bate",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
      }, " 试用 ")) : __props.orgInfo.status !== 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "title-bate",
        onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onClick && _ctx.onClick(...args))
      }, _toDisplayString(__props.orgInfo.status === 1 ? '暂停' : '过期'), 1)) : _createCommentVNode("", true)])) : _unref(route).path === '/home/noorg' ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
        key: 1,
        separator: "/",
        class: "current-routes"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(" 暂未加入机构 ")]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_breadcrumb, {
        key: 2,
        separator: "/",
        class: "current-routes"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRoutes.value, item => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: item.key + item.path
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "on-updata-style",
        onClick: onCloudHosting
      }, [_createVNode(_component_el_image, {
        class: "icon-cloud-disk-storage",
        src: _unref(iconCloudDiskStorage),
        fit: "contain"
      }, null, 8, ["src"]), _createTextVNode(" 云盘存储 ")]), _createVNode(_component_el_dropdown, {
        "popper-class": "org-switch-pop"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgList.value, org => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              class: _normalizeClass(`${orgActive.value}` === `${org.organizationId}` ? 'org-item active' : 'org-item'),
              onClick: $event => submitChangeOrg(org.organizationId),
              key: org.organizationId
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(org.organizationName), 1)]),
              _: 2
            }, 1032, ["class", "onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }), _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: onQRCodeForClueCollection
          }, {
            default: _withCtx(() => [_createTextVNode("线索采集二维码")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[2] || (_cache[2] = $event => userVisible.value = true)
          }, {
            default: _withCtx(() => [_createTextVNode("更换账号")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[3] || (_cache[3] = $event => passVisible.value = true)
          }, {
            default: _withCtx(() => [_createTextVNode("修改密码")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_createTextVNode("退出登录")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [userInfo.value.headerImg ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "user-avatar",
          src: userInfo.value.headerImg || _unref(accountIcon)
        }, null, 8, _hoisted_8)) : _createCommentVNode("", true), !userInfo.value.headerImg && userInfo.value?.realName ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "user-avatar",
          style: _normalizeStyle({
            backgroundColor: ['#FD4482', '#6C93FF', '#FEB736', '#FF895A'][userInfo.value?.realName?.length % 4]
          })
        }, _toDisplayString(userInfo.value?.realName.charAt(userInfo.value?.realName?.length - 1)), 5)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_9, _toDisplayString(userInfo.value.realName), 1)])]),
        _: 1
      })])]), _createVNode(_component_el_dialog, {
        "destroy-on-close": "",
        class: "paasword-change-dialog",
        modelValue: passVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => passVisible.value = $event),
        width: "500px",
        title: "修改密码"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ResetPassword), {
          onChangeLoginType: logout,
          userInfo: userInfo.value,
          showLogin: false
        }, null, 8, ["userInfo"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        "destroy-on-close": "",
        class: "paasword-change-dialog",
        modelValue: qRCodeForClueCollection.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => qRCodeForClueCollection.value = $event),
        width: "500px",
        title: "线索采集二维码"
      }, {
        default: _withCtx(() => [_hoisted_10, _createVNode(_component_el_image, {
          src: personalQrcode.value,
          fit: "contain"
        }, null, 8, ["src"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        "before-close": handleBeforeClose,
        "destroy-on-close": "",
        class: "user-name-change-dialog",
        modelValue: userVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => userVisible.value = $event),
        width: "500px",
        title: "更换账号"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ResetPassword), {
          showLogin: false,
          onChangeLoginType: logout,
          userInfo: userInfo.value,
          accountAction: accountAction.value,
          isAccount: isAccount.value,
          onOnChangeAccount: onChangeAccount,
          type: "account"
        }, null, 8, ["userInfo", "accountAction", "isAccount"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};